import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toHandlers as _toHandlers, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = {
  key: 0,
  draggable: "false",
  class: "gfu-table__cell gfu-table__cell--drag"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")

  return (_openBlock(), _createElementBlock("div", _mergeProps({
    class: ['gfu-table__row', $options.classes, $options.dragDirectionClass],
    onClick: _cache[3] || (_cache[3] = $event => (_ctx.$emit('click')))
  }, _toHandlers($options.dragListeners, true)), [
    ($props.isDraggable)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("a", {
            href: "",
            draggable: "true",
            onDragstart: _cache[0] || (_cache[0] = $event => (_ctx.$emit('drag-start', $props.dragPayload))),
            onDragend: _cache[1] || (_cache[1] = $event => (_ctx.$emit('drag-end', $props.dragPayload))),
            onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _createVNode(_component_base_icon, { name: "grip-lines" })
          ], 32 /* NEED_HYDRATION */)
        ]))
      : _createCommentVNode("v-if", true),
    _renderSlot(_ctx.$slots, "default")
  ], 16 /* FULL_PROPS */))
}